<div ngbDropdown class="d-inline-block" placement="bottom-end">
  <button
    type="button"
    id="calendar-selection"
    class="btn btn-outline"
    ngbDropdownToggle
    [disabled]="!selectedPeriodEndDate"
  >
    <i-lucide name="calendar"></i-lucide>

    @if (selectedPeriodStartDate && selectedPeriodEndDate) {
      {{ selectedPeriodStartDate | aadaterange: selectedPeriodEndDate : false }}
    }
    @if (!selectedPeriodStartDate && !selectedPeriodEndDate) {
      <em>(Loading calendars&hellip;)</em>
    }
  </button>
  <div
    ngbDropdownMenu
    class="date-range-selector"
    aria-labelledby="calendar-selection"
  >
    @for (group of periodNavGroups; track $index; let first = $first) {
      @if (!first) {
        <hr />
      }
      <h5>{{ group.name }}</h5>
      <div class="dropdown-row">
        @for (calendarPeriod of group.items; track $index) {
          <button
            type="button"
            ngbDropdownItem
            class="btn btn-outline-dark btn-calendar"
            [class.active-item]="
              calendarPeriod.startDate === selectedPeriodStartDate &&
              calendarPeriod.endDate === selectedPeriodEndDate
            "
            [disabled]="!calendarPeriod.isSelectionAvailable"
            (click)="
              onUserChangedCalendarPeriod(
                calendarPeriod.startDate,
                calendarPeriod.endDate
              )
            "
          >
            <div class="item-icon">
              @if (calendarPeriod.gridIcon) {
                @for (dot of calendarPeriod.gridIcon; track $index) {
                  <span class="dot" [class.dot-active]="dot"></span>
                }
              }

              @if (calendarPeriod.icon) {
                <i-lucide
                  name="{{ calendarPeriod.icon }}"
                  class="giant-icon"
                ></i-lucide>
              }
            </div>
            <div
              [innerText]="
                calendarPeriod.startDate
                  | aadaterange: calendarPeriod.endDate : true
              "
              class="date"
            ></div>
            <div [innerText]="calendarPeriod.name" class="name"></div>
          </button>
        }
      </div>
    }

    <hr />
    <div>
      <button
        class="btn btn-outline w-100"
        type="button"
        (click)="openSelectPeriodModal()"
      >
        Select period&hellip;
      </button>
    </div>
  </div>
</div>
